import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import { createMarkup } from 'lib/Utils'
import { connect } from 'react-redux'
// import { selectLocation } from 'store/officeLocation'
import { selectService } from 'store/selectedService'
import './index.scss'

class BulletNav extends Component {
  renderBullets () {
    const services = this.props.listedServices
    return (
      services.map((service) => {
        let classes = (this.props.selectedService === service.ID) ? 'active' : ''
        return (
          <li
            className={classes}
            key={`bullet${service.ID}`}
            onClick={() => { if (this.props.allowNavigation) this.props.selectService(service.ID) }} />
        )
      })
    )
  }

  render () {
    let classes = (this.props.selectedService === null) ? 'active' : ''
    return (
      <ul className='bullet-nav list-unstyled'>
        <li
          className={classes}
          key={`bullet0`}
          onClick={() => { if (this.props.allowNavigation) this.props.selectService(null) }}/>
        { this.renderBullets() }
      </ul>
    )
  }

  // componentDidMount() {
  //   this.setState({ someKey: 'otherValue' })
  // }
}

BulletNav.propTypes = {
  selectService: PropTypes.func,
  selectedService: PropTypes.number,
  listedServices: PropTypes.array,
  allowNavigation: PropTypes.bool
}

const mapStateToProps = (state) => ({
  listedServices: state.listedServices,
  selectedService: state.selectedService
})

const mapDispatchToProps = {
  selectService: (serviceID) => selectService(serviceID)
}

export default connect(mapStateToProps, mapDispatchToProps)(BulletNav)



// WEBPACK FOOTER //
// ./src/containers/BulletNav/index.js